// @ts-ignore
import {ref, onMounted, onUnmounted} from 'vue'

export const fullScreenHook = (emit:any) => {
    const isFullScreen = ref(false)
    const onFullScreenChange = () => {
        if (document.fullscreenElement) {
            console.log('进入全屏')
            isFullScreen.value = true;
          } else {
            console.log('退出全屏')
            isFullScreen.value = false;
          }
          emit('toggle-fullscreen', isFullScreen.value)
    }
    const toggleFullScreen = () => {
        if (isFullScreen.value) {
            // 判断当前浏览器是否处于全屏状态
            if (document.fullscreenElement) {
              // 如果处于全屏状态，则退出全屏
              document.exitFullscreen();
            }
            isFullScreen.value = false;
    
          } else {
            // 获取要全屏的元素
            const elem = document.documentElement;
            // 判断当前浏览器是否支持全屏API
            if (elem.requestFullscreen) {
              // 如果支持，则调用全屏方法
              elem.requestFullscreen();
            }
            isFullScreen.value = true;
          }
          emit('toggle-fullscreen', isFullScreen.value)
    }
    onMounted(() => {
        document.addEventListener('fullscreenchange', onFullScreenChange)
    })
    onUnmounted(() => {
        document.removeEventListener('fullscreenchange', onFullScreenChange)
    })

    return {
        isFullScreen,
        toggleFullScreen
    }
}